module.exports = __webpack_public_path__ + "roboto-light-webfont.52488b1cbcddf583c6f9.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/roboto-light-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto-light-webfont.ttf
// module chunks = styles